/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  clips: []
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetAllTrimClipsAction.REQUEST_ALLTRIMCLIPS:
      return {
        ...state
      };
    case actions.GetAllTrimClipsAction.ALLTRIMCLIPS_RECEIVED:
      return {
        ...state,
        clips: action.data
      };

    default:
      return state;
  }
};

export default reducer;
